import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import axios from 'axios';
import { useWeb3React } from '@web3-react/core';
import ConnectButton from '../../components/ConnectButton';
import RainbowBalancePanel from '../../components/RainbowBalancePanel';
import YourCollectionPanel from '../../components/YourCollectionPanel';

import styles from '../../styles/Stake.module.scss';
//import StakeNav from '../../components/StakeNav';
import { Spinner } from 'react-bootstrap';

const Stake = () => {
  const { active } = useWeb3React();
  const [synced, setSynced] = useState(false);
  const [enableWithdrawals, setEnableWithdrawals] = useState(false);
  const router = useRouter();

  useEffect(() => {
    Promise.all([
      axios.post('/api/sync'),
      axios.post('/api/sync/withdrawals'),
    ]).finally(() => {
      setSynced(true);
    });
  }, []);

  useEffect(() => {
    const enableWithdrawals =
      process.env.NEXT_PUBLIC_ENABLE_WITHDRAWALS === 'true' ||
      router.query.withdrawals === 'true';
    setEnableWithdrawals(enableWithdrawals);
  }, [router]);

  if (!active) {
    return (
      <div className="pink-gradient">
        <div className="container py-5 text-center">
          <p className="lead">Please connect your wallet</p>
          <ConnectButton />
        </div>
      </div>
    );
  }

  // if (!synced) {
  //   return (
  //     <div className="pink-gradient">
  //       <div className="container py-5 text-center">
  //         <Spinner animation="border" role="status">
  //           <span className="visually-hidden">Loading...</span>
  //         </Spinner>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <>
      <Head>
        <title>Dashboard | Noundles</title>
      </Head>

      <div className="pink-gradient">
        <div className={styles.rainbow}>
          <div className="container py-5">
            <div className="py-3">
              <div className={styles.card}>
                <YourCollectionPanel />
              </div>
            </div>
            <div className="py-3">
              <div className={styles.card}>
                <RainbowBalancePanel enableWithdrawals={enableWithdrawals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stake;
